"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IsMobileContext = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UICardGrid = _interopRequireDefault(require("UIComponents/card/UICardGrid"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _HighlightedMerchCard = _interopRequireDefault(require("./HighlightedMerchCard"));

var _HighlightedMerchHeaderConfig = _interopRequireDefault(require("pricing-pages-unified-ui/constants/HighlightedMerchHeaderConfig"));

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _partial = _interopRequireDefault(require("transmute/partial"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _wtDebounce = _interopRequireDefault(require("../../utils/wtDebounce"));

var _MarketingContactsSelectors = require("pricing-pages-unified-ui/selectors/MarketingContactsSelectors");

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    &:first-child {\n      margin-bottom: -1px;\n      margin-right: 0;\n      border-radius: 3px 3px 0 0;\n    }\n    &:last-child {\n      margin-top: -1px;\n      margin-left: 0;\n      border-radius: 0 0 3px 3px;\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-direction: column;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    grid-template-columns: 1fr;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: block;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// The funky static width below is for an IE bug
var CardGrid = (0, _styledComponents.default)(_UICardGrid.default).withConfig({
  displayName: "HubTierInfo__CardGrid",
  componentId: "sc-1fvn5fk-0"
})(["width:", "px;", " ", " ", ";"], function (props) {
  return props.columns * 384 + (props.columns - 1) * 24;
}, _responsiveBreakpoints.default.sd(_templateObject()), _responsiveBreakpoints.default.tabletPortrait(_templateObject2()), _responsiveBreakpoints.default.phone(_templateObject3()));

var SelectorButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "HubTierInfo__SelectorButtonWrapper",
  componentId: "sc-1fvn5fk-1"
})(["display:flex;width:80%;margin:0 auto;", ""], _responsiveBreakpoints.default.phoneLarge(_templateObject4()));

var SelectorButton = _styledComponents.default.button.withConfig({
  displayName: "HubTierInfo__SelectorButton",
  componentId: "sc-1fvn5fk-2"
})(["font-size:0.75rem;padding:calc(1rem + 1px) 2rem;background:#fff;flex-grow:1;flex-basis:33%;border:1px solid #7fd1de;transition:background-color 0.3s;&:first-child{margin-right:-1px;border-radius:3px 0 0 3px;}&:last-child{margin-left:-1px;border-radius:0 3px 3px 0;}&:hover{background-color:#e5f5f8;}&.active{font-weight:500;padding:1rem 2rem;border-width:2px;border-color:#00a4bd;background-color:#e5f5f8;}", ""], _responsiveBreakpoints.default.phoneLarge(_templateObject5()));

var isWidthMobile = function isWidthMobile(width) {
  return width <= 800;
};

var IsMobileContext = _react.default.createContext(isWidthMobile(window.innerWidth));

exports.IsMobileContext = IsMobileContext;

var HubTierInfo = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(HubTierInfo, _React$Component);

  function HubTierInfo(props) {
    var _this;

    (0, _classCallCheck2.default)(this, HubTierInfo);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(HubTierInfo).call(this, props));

    _this.handleWindowSizeChange = function () {
      _this.setState({
        width: window.innerWidth
      });
    };

    _this.handleKeyChange = function (selectedId) {
      return _this.setState({
        selectedId: selectedId,
        activeCard: selectedId
      });
    };

    _this.state = {
      width: window.innerWidth,
      selectedId: 0,
      activeCard: 0
    };
    return _this;
  }

  (0, _createClass2.default)(HubTierInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          isInMCBeta = _this$props.isInMCBeta,
          hub = _this$props.hub;
      var highlightedPaidMerch = isInMCBeta && hub === _Hubs.default.HUB_MARKETING ? _HubMap.default[hub].highlightedPaidMerchMCBeta : _HubMap.default[hub].highlightedPaidMerch;
      this.setState({
        selectedId: highlightedPaidMerch[0],
        activeCard: highlightedPaidMerch[0]
      });
      var resizeWindow = (0, _wtDebounce.default)(function () {
        _this2.handleWindowSizeChange();
      }, 250);
      window.addEventListener('resize', resizeWindow);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowSizeChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          hub = _this$props2.hub,
          isInMCBeta = _this$props2.isInMCBeta;
      var highlightedMerch = isInMCBeta && hub === _Hubs.default.HUB_MARKETING ? _HubMap.default[hub].highlightedPaidMerchMCBeta : _HubMap.default[hub].highlightedPaidMerch;
      var isMobile = isWidthMobile(this.state.width);

      if (isMobile) {
        return _react.default.createElement(IsMobileContext.Provider, {
          value: isMobile
        }, _react.default.createElement(SelectorButtonWrapper, null, highlightedMerch.map(function (merchId) {
          return _react.default.createElement(SelectorButton, {
            key: merchId,
            onClick: (0, _partial.default)(_this3.handleKeyChange, merchId),
            className: _this3.state.activeCard === merchId ? 'active' : ''
          }, _react.default.createElement(_FormattedMessage.default, {
            message: _HighlightedMerchHeaderConfig.default[merchId].title
          }));
        })), this.state.selectedId > 0 && _react.default.createElement(_HighlightedMerchCard.default, {
          hub: hub,
          merchandiseId: this.state.selectedId
        }));
      }

      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_UIFlex.default, {
        justify: "center"
      }, _react.default.createElement(CardGrid, {
        className: "hub-tier-info",
        columns: highlightedMerch.length,
        columnSize: 384,
        gutterSize: 24
      }, highlightedMerch.map(function (merchId) {
        return _react.default.createElement(_HighlightedMerchCard.default, {
          key: merchId,
          hub: hub,
          merchandiseId: merchId,
          setEnterpriseVisible: _this3.handleSetEnterpriseVisible,
          hasSimplifyTabs: _this3.props.hasSimplifyTabs
        });
      }))));
    }
  }]);
  return HubTierInfo;
}(_react.default.Component);

HubTierInfo.propTypes = {
  hub: _propTypes.default.string.isRequired,
  hasSimplifyTabs: _propTypes.default.bool,
  isInMCBeta: _propTypes.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state),
    isInMCBeta: (0, _MarketingContactsSelectors.isInMCBetaSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(HubTierInfo);

exports.default = _default;